<template>
<div class="form-wrapper">
  <v-form id="custom-form" action="/"
    class="row custom-row"
    v-model="valid"
    ref="form"
    method="POST"
    name="beraten-formular"
    @submit.prevent="sendToNetlify"
    >
    <v-col
      cols="12"
      md="6"
      class="input-wrap"
    >
      <input type="hidden" name="form-name" value="beraten-lassen" />
        <v-text-field
          v-model="vornachname"
          name="vornachname"
          :rules="nameRules"
          required
          class="custom-lable"
        >
          <template v-slot:label>
            <span class="input__label">
              Ihr Name
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="input-wrap"
      >
        <v-text-field
          v-model="email"
          :rules="emailRules"
          name="email"
          required
        >
          <template v-slot:label>
            <span class="input__label">
              Ihre E-Mail
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-row class="btn-row">
      <v-col
        cols="12"
      >
        <button type="submit" class="btn">
            <div class="text">
              Abschicken <img src="/images/pfeil_icon_beratung_anfordern.png" />
            </div>
          </button>
      </v-col>
    </v-row>
  </v-form>
  <v-row>
      <v-col id="form-success">
        <h2>Vielen Dank für Ihre Anfrage.</h2>
      </v-col>

      <v-col id="form-fail">
        <h2>Sorry, da ging was schief</h2>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>

  .btn-row {
    width: 100%;
  }

  .form-wrapper {
    width: 100%;
  }

  .input-wrap {
    max-width: 497px;
  }

  .custom-row {
    max-width: 1050px;
    margin: 98px auto 0 auto;
  }

   #custom-form {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  #form-success,
  #form-fail {
    display: none;

    h2 {
      font-family: "museo-sans", sans-serif;
      font-size: 1.667rem;
      color: rgba(0, 0, 0, 0.87);
      margin-left: 0;
      margin-bottom: 1rem;
    }
  }

  #form-success {
    font-family: "museo-sans", sans-serif;
    flex-direction: column;
    padding: 0;
    text-align: center;

    h2 {
      font-family: "museo-sans", sans-serif;
      font-size: 1.667rem;
      color: rgba(0, 0, 0, 0.87);
      margin-left: 0;
      margin-bottom: 1rem;
    }

    p {
      font-family: "museo-sans", sans-serif;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .input__label {
    color: rgba(0, 0, 0, 0.87);
  }

  .btn {
    display: flex;
    margin: 60px auto 0 auto;

    &:hover {
      cursor: pointer;
    }

    img {
      position: relative;
      bottom: -4px;
      width: 1.8rem;
    }

    .text {
      font-family: "ltc-bodoni-175", serif;
      font-style: italic;
      font-size: 2.053rem;
    }
  }

  @media screen and (max-width: 959px) {
    #custom-form {
      justify-content: center;
    }

    .custom-row {
      margin: 6% auto 0 auto;
    }

    .btn {
      margin: 0 auto;

      .text {
        font-size: 2rem;
      }

    img {
        max-width: 2rem;
      }
    }
  }

</style>

<script>
const axios = require('axios');

export default {
  data: () => ({
    valid: false,
    email: '',
    vornachname: '',
    checkbox: '',
    emailRules: [
      (v) => !!v || 'Bitte eine E-Mail-Adresse angeben.',
      (v) => /.+@.+/.test(v) || 'Bitte eine gültige E-Mail-Adresse angeben.',
    ],
    nameRules: [
      (v) => !!v || 'Bitte geben Sie Ihren Namen an.',
    ],
  }),
  methods: {
    sendToNetlify() {
      let formData;
      this.$refs.form.validate();
      if (this.valid) {
        formData = `form-name=beraten-formular&email=${this.email}&vornachname=${this.vornachname}`;
        axios.post(document.getElementById('custom-form').getAttribute('action'), formData)
          .then((response) => {
            document.getElementById('custom-form').classList.add('d-none');
            if (response.status === 200) {
              document.getElementById('form-success').classList.add('d-flex');
            } else {
              document.getElementById('form-fail').classList.add('d-flex');
            }
          });
      }
    },
  },
};

</script>
